const Regex = {
  emailValidation: /^(\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*\s*[,]?\b)*$/g,
  phoneNoValidation: /^(\+\d{1,3}[- ]?)?\d{10}$/,
  nameValidation: /^[a-z,.'-]+$/i,
};

export default Regex;
